"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const react_1 = require("react");
const rootStyle = core_1.css `
  background-color: ${design_system_1.Colors.grey000};
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  line-height: 25px;
  padding: 50px 30px;
  text-align: center;
`;
const headerStyle = core_1.css `
  margin-bottom: 6px;
  margin-top: 10px;
`;
const illustrationStyle = core_1.css `
  font-size: 40px;
  margin-bottom: 8px;
  margin-right: 10px;
`;
const messageStyle = core_1.css `
  font-size: 16px;
  color: ${design_system_1.Colors.grey700};
`;
const buttonsContainerStyle = core_1.css `
  padding-top: 20px;
`;
const buttonWrapperStyle = core_1.css `
  margin: 5px;
`;
const waitingLabelStyle = core_1.css `
  margin-right: 10px;
`;
const waitingWrapperStyle = core_1.css `
  display: flex;
`;
const CTAMessage = (props) => (core_1.jsx("div", { css: rootStyle },
    core_1.jsx("div", { css: illustrationStyle }, 'illustration' in props ? (props.illustration) : (core_1.jsx(common_components_1.Emoji, { label: props.emojiLabel, symbol: props.emojiSymbol }))),
    core_1.jsx("div", { css: headerStyle },
        core_1.jsx(design_system_1.Text, { tag: "p", type: "subtitle800" }, props.headerText)),
    core_1.jsx("div", { css: messageStyle }, props.message),
    core_1.jsx("div", { css: buttonsContainerStyle }, props.isWaiting ? (core_1.jsx(design_system_1.Button, { disabled: true, size: "medium" },
        core_1.jsx("span", { css: waitingWrapperStyle },
            core_1.jsx("span", { css: waitingLabelStyle }, props.waitingText),
            ' ',
            core_1.jsx(design_system_1.Spinner, { size: "small" })))) : (core_1.jsx(react_1.Fragment, null,
        core_1.jsx("span", { css: buttonWrapperStyle },
            core_1.jsx(design_system_1.Button, { color: "grey", onClick: props.onSecondaryButtonClick, size: "medium" }, props.secondaryButtonText)),
        core_1.jsx("span", { css: buttonWrapperStyle },
            core_1.jsx(design_system_1.Button, { color: "blue", hasShadow: true, onClick: props.onPrimaryButtonClick, size: "medium" }, props.primaryButtonText)))))));
exports.default = CTAMessage;
